// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__oAPln","overlay":"Loader_overlay__6Dat5","buttonContainer":"Loader_buttonContainer__FTKTZ"};